export default __webpack_public_path__ + "static/media/section-1-bg-trans.43dc25f4.png";